/* Campaign pop-up (snippets/btk-offer-popup) with data-trigger="after-consent":
   opens once the page has gone data-delay seconds with no cookie notice showing,
   so the two never sit on top of each other. pop-up.js ignores this trigger, and
   still handles closing and the dismissal cookie. Moved to <body> on opening
   because the planner page hides the header section it is rendered in. */
(function () {
  var popup = document.querySelector('pop-up[data-trigger="after-consent"]');
  if (!popup) return;

  function dismissed() {
    return document.cookie.split('; ').some(function (c) { return c.indexOf(popup.id + '-dismissed=') === 0; });
  }

  function noticeShowing() {
    var notice = document.querySelector('#shopify-pc__banner .shopify-pc__banner__dialog') || document.getElementById('shopify-pc__banner');
    if (!notice) return false;
    var box = notice.getBoundingClientRect();
    return box.height > 0 && getComputedStyle(notice).visibility !== 'hidden' && getComputedStyle(notice).display !== 'none';
  }

  customElements.whenDefined('pop-up').then(function () {
    if (dismissed()) return;
    if (popup.dataset.showOnMobile !== 'true' && !theme.mediaMatches.md) return;
    var clearMs = 0;
    var waitMs = Number(popup.dataset.delay) * 1000;
    var timer = setInterval(function () {
      clearMs = noticeShowing() ? 0 : clearMs + 500;
      if (clearMs < waitMs) return;
      clearInterval(timer);
      document.body.appendChild(popup);
      popup.open();
    }, 500);
  });
})();
